export class Attachment {
  file: File;
  name: string;
  size: number;
  location: string;
  uploading: boolean;
  uploadSuccessful: boolean;
  uploadInvalid: boolean;
  id: number;
  isDeleted: boolean;
}
